<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-book-open-page-variant" 
        v-bind:show.sync="dialog"
        maxWidth="40%"
        :showButton="false"
    >
        <template v-slot:tools>
           
        </template>
        
        <template v-slot:form>

            <v-container>
                <v-row>
                    <v-col  cols="12" sm="12">
                        <v-alert
                            border="top"
                            colored-border
                            type="info"
                            elevation="2"
                        >
                            <span v-if="newItem">
                                Informe a data, horário e tipo de ocorrência
                            </span>
                            <span v-else>
                                Selecione o tipo de ocorrência a ser
                                cadastrada e justifique.
                            </span>
                        </v-alert>
                    </v-col>
                   
                </v-row>
                <v-row v-if="newItem">
                    <v-col  cols="12" sm="6">
                        <emc-calendar-date-picker2
                            :model.sync="newModel.date" 
                            label="Data*" 
                            :error="errors.length > 0"
                            :error-messages="errors.date" 
                            :show="dialog"
                            :min="dateMin"
                            :max="dateMax"
                            :allowed-dates="allowedDates"
                            dense
                        />
                    </v-col>
                     <v-col  cols="12" sm="3">
                        <s-text-field v-mask="'00:00'" dense clearable placeholder="HH:MM" :rules="[validateTime]" :error-messages="errors.hour_start1" v-model="newModel.hour_start1" label="Início*" />
                     </v-col>
                     <v-col  cols="12" sm="3">
                        <s-text-field  v-mask="'00:00'" dense clearable placeholder="HH:MM" :rules="[validateTime]" :disabled="!newModel.hour_start1 && !newModel.hour_end1" :error-messages="errors.hour_end1" v-model="newModel.hour_end1" label="Fim*" />
                     </v-col>
                </v-row>
                <v-row>
                    <v-col  cols="12" sm="12">
                        <sys-select-occurrence-type
                            :model.sync="newModel.occurrence_type_id"
                            label="Tipo de Ocorrência*"
                            :filterAdditional="newItem ? 1 : 0"
                            hideHolliday
                            @change="changeType"
                            show-description
                        />
                    </v-col>
                </v-row>
                <v-row v-if="selectedOccurrenceType && selectedOccurrenceType.link">
                    <v-col  cols="12" sm="12">
                        <a :href="selectedOccurrenceType.link">Cadastrar Atestado - SOUANIMA</a>
                    </v-col>
                </v-row>
                <v-row v-if="selectedOccurrenceType && selectedOccurrenceType.requires_motive">
                    <v-col  cols="12" sm="12">
                        <sys-select-occurrence-motive
                            :model.sync="newModel.occurrence_sheet_register_motive_id"
                            label="Motivo*"
                            
                        />
                    </v-col>
                </v-row>
                <v-row v-if="selectedOccurrenceType && selectedOccurrenceType.occurrence_record_type_id == 1">
                    <v-col  cols="12" sm="12">
                        <v-select
                            v-model="attribution"
                            item-value="id"
                            item-text="name"
                            :items="attributions"
                            label="Selecione a UC"
                            dense
                            return-object
                            :loading="loadingAttribution"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="selectedOccurrenceType && selectedOccurrenceType.occurrence_record_type_id == 2 && activities.length">
                    <v-col  cols="12" sm="12">
                        <v-select
                            v-model="activityItem"
                            item-value="id"
                            item-text="name"
                            :items="activities"
                            label="Selecione a Atividade"
                            dense
                            return-object
                            :loading="loadingAttribution"
                        />
                    </v-col>
                        
                </v-row>
                        <v-row>
                            <v-col  cols="12" sm="12">
                                <v-textarea
                                    v-if="newItem"
                                    v-model="newModel.description" 
                                    :label="'Descrição (Mínimo ' + minNote +  '  caracteres)'"
                                    :counter="maxNote"
                                    :rules="[v => (!v || v.length <= maxNote) || 'Máximo de ' + maxNote + ' caracteres atingido']"
                                    outlined
                                    :aria-placeholder="'Informe uma descrição com no mínimo' + minNote + 'caracteres'"
                                    :error="errors.length > 0" 
                                    :error-messages="errors.description" 
                                />
                                <v-textarea
                                    v-else
                                    v-model="newModel.note" 
                                    :label="'Justificativa* (Mínimo ' + minNote +  '  caracteres)'"
                                    :counter="maxNote"
                                    :rules="[v => (!v || v.length <= maxNote) || 'Máximo de ' + maxNote + ' caracteres atingido']"
                                    outlined
                                    :aria-placeholder="'Informe uma justificativa com no mínimo' + minNote + 'caracteres'"
                                    :error="errors.length > 0" 
                                    :error-messages="errors.note" 
                                />
                            </v-col>
                            
                        </v-row>
           
            </v-container>

            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>

            <emc-alert-modal title="Ocorrências de Ponto" icon="mdi-book-open-page-variant" text="Confirma o cadastro da ocorrência?" :disabled="loading" v-bind:show.sync="showQuestion">
                
                <template v-slot:actions>
                    <v-btn color="primary" @click.prevent.stop="save()" :loading="loading" >Sim - Cadastrar</v-btn>
                </template>

            </emc-alert-modal>

        </template>

        <template v-slot:actions>
            <v-btn  color="primary" @click.prevent.stop="showQuestion = true" :disabled="disabledSave">Cadastrar Ocorrência<v-icon right dark>mdi-calendar-minus</v-icon></v-btn>
        </template>
       
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceTeacherRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        minNote: 5,
        maxNote: 255,
        selectedOccurrenceType: null,
        newModel: {},
        dateMin: null,
        dateMax: null,
        showQuestion: false,
        attributions: [],
        attribution: null,
        activities: [],
        loadingAttribution: false,
        activities: [],
        activityItem: null
    }),
    created(){
        
    },

    computed: {
      ...mapState('auth', ['acesso']),

      disabledSave(){
        
            if(!this.newModel){
                return true;
            }
        
            let value = true;

            if(this.newItem){

                value = this.loading || !this.newModel.date || !this.newModel.hour_start1 || !this.newModel.hour_end1 || (this.newModel.desription && (this.newModel.desription.length < this.minNote || this.newModel.desription.length > this.maxNote)) || !this.newModel.occurrence_type_id;

                

            }else{
                
                if(!this.newModel.note){
                    return true;
                }
                
                value = this.loading || this.newModel.note === null || this.newModel.note.length < this.minNote || this.newModel.note.length > this.maxNote || !this.newModel.occurrence_type_id;

            }
            
            if(this.selectedOccurrenceType && this.selectedOccurrenceType.requires_motive){
                value = value || !this.newModel.occurrence_sheet_register_motive_id;
            }

            return value;

        },

    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.attribution = null;
                this.attributions = [];
                this.selectedOccurrenceType = null;
                this.activities = [];
                this.activityItem = null;

            }
        },

        model(val){
            this.newModel = val;
        }
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-book-open-page-variant"
        },
        title: {
            type: String,
            default: "Ocorrências de Ponto"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        newItem: {
            required: true
        },
        allowedDates: {

        }
    },
    methods:{
        ...mapActions('timeSheet', ['ActionAbsenceRegisterSheetItem', 'ActionStoreOccurrenceSheetItem']),
        ...mapActions('attribution', ['ActionFindAttributions']),
        ...mapActions('activityItem', ['ActionFindActivityItems']),

        save(){
          
          this.loading = true;
          this.error = false;
          this.message = '';
          this.errors = {};
          let method = this.newItem ? 'ActionStoreOccurrenceSheetItem' : 'ActionAbsenceRegisterSheetItem';

          if(this.newItem){
            
            this.newModel.occurrence_sheet_id = this.model.occurrence_sheet_id;
            this.newModel.occurrence_record_type_id = 1;

            this.newModel.registers = [];

            this.newModel.registers.push({
                id:                                 0,
                occurrence_sheet_item_id:           this.newModel.occurrence_sheet_id,
                occurrence_intervention_type_id:    1, // 1 = Original | 2 = Incluído | 4 = Exceção
                date:                               this.newModel.date,
                time:                               this.newModel.hour_start1,
            });

             this.newModel.registers.push({
                id:                                 0,
                occurrence_sheet_item_id:           this.newModel.occurrence_sheet_id,
                occurrence_intervention_type_id:    1, // 1 = Original | 2 = Incluído | 4 = Exceção
                date:                               this.newModel.date,
                time:                               this.newModel.hour_end1,
            });

            if(this.attribution){
                
                if(this.newModel.description){
                    this.newModel.description = this.attribution.name + ' - ' + this.newModel.description;
                }else{
                    this.newModel.description = this.attribution.name;
                }
            }

            if(this.activityItem){
                
                if(this.newModel.description){
                    this.newModel.description = this.activityItem.name + ' - ' + this.newModel.description;
                }else{
                    this.newModel.description = this.activityItem.name;
                }
                
                
            }

          }

          this[method](this.newModel)
            .then((res) => {
                
                this.$emit('onCompleted');

            })
            .catch((error) =>{
                
                this.message = error.message;
                this.error = true;
                this.errors = error.errors;
                this.showQuestion = false;

            })
            .finally(() => {
                  this.loading = false;
            });
      },

      changeType(ev){
            
            this.selectedOccurrenceType = ev;
            this.newModel.occurrence_sheet_register_motive_id = null;
            this.attribution = null;
            this.activityItem = null;

            if(this.selectedOccurrenceType.occurrence_record_type_id == 1){
                this.loadAttributions();
            }else if(this.selectedOccurrenceType.occurrence_record_type_id == 2){
                this.loadActivities();
            }

        },

    loadAttributions(){
        
        this.attributions = [];
        this.attribution = null;
        this.loadingAttribution = true;
        
        let payload  = {
            find_columns: {
                teacher_id: this.model.teacher_id,
                attribution_status_id: 1
            },
            columns: 'id,grid_id,attribution_status_id,teacher_id,work_time_id',
            with: 'grid|grid.group:id,name,campus_id|grid.discipline:id,name|grid.join'
        };

        this.ActionFindAttributions(payload)
            .then((res) => {
                
                let grids = [];
                
                res.data.forEach(att => {
                    
                    let name = att.grid.group.name + ' - ' + att.grid.discipline.name;
                    
                    if(!grids.includes(name) && (!att.grid.join || att.grid.join.main)){
                        
                        grids.push(name);
                        
                        this.attributions.push({
                            id: att.id,
                            name: name
                        });

                        
                    }
                    
                });

                this.attributions.sort();

            })
            .catch((error) =>{
                
            })
            .finally(() => {
                 this.loadingAttribution = false;
            });
      },

      loadActivities(){
        
        this.activities = [];
        this.activityItem = null;
        this.loadingAttribution = true;
        
        let payload  = {
            filter_relations: [
                {
                    name:   'teachers',
                    key:    'activity_item_teachers.teacher_id', 
                    value:  this.model.teacher_id,
                },
            ],
            columns: 'id,activity_id',
            with: 'activity:id,name'
        };

        this.ActionFindActivityItems(payload)
            .then((res) => {
                
                let acts = [];
                
                res.data.forEach(item => {
                    
                    if(!acts.includes(item.activity_id)){
                        
                        acts.push(item.activity_id);
                        
                        this.activities.push({
                            id:     item.activity_id,
                            name:   item.activity.name
                        });
                    }
                    
                });

                 this.activities.sort();

            })
            .catch((error) =>{
                
            })
            .finally(() => {
                 this.loadingAttribution = false;
            });
      },

        validateTime(value) {
        
            if (!value) return true // Se vazio, sem erro
            if (value.length === 0) return true // sem erro se vazio
            if (value.length < 5) return true   // ainda digitando, não valida
            
            const regex = /^([01]\d|2[0-3]):([0-5]\d)$/
            return ( regex.test(value)) || 'Hora inválida. Use o formato HH:MM (00:00 a 23:59)'
        },

    

    }
}
</script>